<template>
	<router-link
		:to="`/case/${item.slug}`"
		:class="['case-thumb', item.slug]"
		@click.native="$emit('click', $event.currentTarget)"
		>
		<p class="case-thumb__date">{{ item.date }}</p>

		<h2>
			{{ item.title }}
			<span class="external-link" v-if="item.link" :title="item.link" @click.prevent="redirect(item.link)">
				<i class="fa fa-external-link"></i>
			</span>
		</h2>

		<p class="case-thumb__text">{{ item.text }}</p>
		
		<img :src="`../img/portfolio/${item.slug}/main.png`" :alt="item.slug">
	</router-link>
</template>

<script>
export default {
	name: 'case-thumb',
	props: ['item'],
	methods: {
		redirect(link) { window.open(link) }
	}
}
</script>

<style lang="sass">
@import '../assets/css/smart-grid'
@import '../assets/css/_vars'

.case-thumb
	display: flex
	flex-direction: column
	position: relative
	margin-bottom: 3rem
	padding: 2rem 2.5rem
	border-radius: $br
	box-shadow: $bs
	transition: $tr
	&:before		
		content: ''
		display: block
		position: absolute
		top: -1rem
		left: -1rem
		width: calc(100% + 2rem)
		height: calc(100% + 2rem)
		background-color: inherit
		border-radius: $br
		transition: $tr
		opacity: 0
		z-index: -1
	&:hover
		transform: scale(1.025) perspective(100rem) rotateZ(.25deg)
		box-shadow: $bsh
		&:before
			opacity: .4
	&__date
		position: absolute
		top: 1rem
		right: 1rem
		opacity: .8
	&__text
		margin-bottom: 2rem

@media screen and (max-width: $break_md)
	.case-thumb
		padding: 1rem 1.25rem
		h2
			font-size: 1.25rem
			padding-right: 1.75rem
		&__date
			top: .75rem
			right: .75rem
			font-size: .75rem
		&__text
			font-size: .85rem
</style>
